@if (request && reqResponse) {
  <div class="mat-dialog-header">
    <h2 mat-dialog-title>
      {{ reqResponse.type ? reqResponse.type : ('BOX_RESPONSES' | translate) }}
    </h2>

    <div class="mat-dialog-header-actions">
      @if (reqResponse.parameters) {
        <button type="button" mat-stroked-button extended (click)="showParameters(reqResponse.parameters)">
          <mat-icon>search_gear</mat-icon>
          {{ 'PARAMETERS' | translate }}
        </button>
      }

      <ng-container *canSee="userType.Admin">
        @if (request && request.PK_CommandRequestID && progress === 0) {
          <button type="button" mat-stroked-button extended (click)="execute()" [disabled]="executing">
            <mat-icon>rocket_launch</mat-icon>
            {{ 'EXECUTE' | translate }}
          </button>
        }
      </ng-container>
    </div>
  </div>

  <mat-dialog-content>
    @if (reqResponse.PK_CommandRequestID && !reqResponse.totalAnswers) {
      <div class="alert alert-soft alert-warning flex items-center gap-4 mb-4" role="alert">
        <mat-spinner color="warning" [diameter]="20"></mat-spinner>
        <div>
          {{ 'PREPARING_REQUEST_TEXT' | translate }}
        </div>
      </div>
    }

    @if (reqResponse.Boxes) {
      <div class="stats mb-4">
        @if (reqResponse.CustomerName) {
          <div class="stat">
            <div class="stat-title">{{ 'INITIATED_BY' | translate }}</div>
            <div class="stat-desc">
              @if (canClickOnCustomer && reqResponse.FK_InitiatedByCustomerID) {
                <a [routerLink]="['users', reqResponse.FK_InitiatedByCustomerID]">
                  {{ reqResponse.CustomerName }}
                </a>
              } @else {
                {{ reqResponse.CustomerName }}
              }
            </div>
          </div>
        }
        <div class="stat">
          <div class="stat-title">{{ 'CREATED' | translate }}</div>
          <div class="stat-desc">{{ reqResponse.CreatedOn | cDate: 'L LTS' }}</div>
        </div>
        <div class="stat">
          <div class="stat-title">{{ 'EXECTUTION_DATE' | translate }}</div>
          <div class="stat-desc">{{ reqResponse.time | cDate: 'L LTS' }}</div>
        </div>
        <div class="stat">
          <div class="stat-title">{{ 'STATUS' | translate }}</div>
          <div class="stat-desc">
            @if (reqResponse.totalAnswers === reqResponse.Boxes.length) {
              <span class="text-success">{{ 'COMPLETED' | translate }}</span>
            } @else if (reqResponse.totalAnswers) {
              <span class="text-warning dot-dot-dot">{{ 'REQUEST_SENT' | translate }}</span>
            } @else {
              <span class="text-warning dot-dot-dot">{{ 'PREPARING' | translate }}</span>
            }
          </div>
        </div>
        <div class="stat">
          <div class="stat-title">{{ 'BOX_ANSWERS' | translate }}</div>
          <div class="stat-desc">{{ reqResponse.totalAnswers }}/{{ reqResponse.Boxes.length }}</div>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-progress-bar
    [color]="reqResponse.PK_CommandRequestID && !reqResponse.totalAnswers ? 'accent' : 'primary'"
    [mode]="reqResponse.PK_CommandRequestID && !reqResponse.totalAnswers ? 'indeterminate' : 'determinate'"
    [value]="progress"></mat-progress-bar>

  <ngx-datatable
    scResizeTable
    [columnMode]="'force'"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [limit]="10"
    [rows]="reqResponse.Boxes"
    [messages]="tableMessages"
    [loadingIndicator]="loading"
    (activate)="showAnswer($event)"
    class="material">
    <ngx-datatable-column prop="" name="{{ 'CHARGE_POINTS' | translate }}" [maxWidth]="200">
      <ng-template let-response="row" ngx-datatable-cell-template>
        @if (response.ChargePoints?.length) {
          <span>
            @for (point of response.ChargePoints; track point; let last = $last) {
              <span>
                <a
                  routerLink="/station/{{ point.FK_ChargingStationID }}/point/{{ point.PK_ChargePointID }}/sessions"
                  (click)="$event.stopPropagation()"
                  target="_blank">
                  {{ point.Name }}
                </a>
                @if (!last) {
                  <span>{{ ', ' }}</span>
                }
              </span>
            }
          </span>
        }
      </ng-template>
    </ngx-datatable-column>
    @if (reqResponse.type === 'SetDefaultConfig' || reqResponse.type === 'SetDefaultAuthentication') {
      <ngx-datatable-column
        prop="parameters"
        name="{{ 'CONFIGURATION' | translate }}"
        [maxWidth]="200"
        [sortable]="true">
        <ng-template let-response="row" ngx-datatable-cell-template>
          @if (response.parameters) {
            <span>
              {{ response.parameters.key ? response.parameters.key : '-' }}
            </span>
          }
          @if (!response.parameters) {
            <span>-</span>
          }
        </ng-template>
      </ngx-datatable-column>
    }
    @if (reqResponse.type === 'SetDefaultConfig' || reqResponse.type === 'SetDefaultAuthentication') {
      <ngx-datatable-column prop="parameters" name="{{ 'CONF_VALUE' | translate }}" [maxWidth]="200" [sortable]="true">
        <ng-template let-response="row" ngx-datatable-cell-template>
          @if (response.parameters) {
            <span class="word-wrap">
              {{ response.parameters.value ? response.parameters.value : '-' }}
            </span>
          }
          @if (!response.parameters) {
            <span>-</span>
          }
        </ng-template>
      </ngx-datatable-column>
    }
    <ngx-datatable-column name="{{ 'STATUS' | translate }}" [maxWidth]="200" [sortable]="true">
      <ng-template let-response="row" ngx-datatable-cell-template>
        <span
          [ngClass]="{
            'txt-secondary': checkStatus(response) === 'COMPLETE',
            'txt-warn dot-dot-dot': checkStatus(response) === 'PENDING',
            'txt-danger': checkStatus(response) === 'FAILED'
          }">
          {{ checkStatus(response) | translate }}
        </span>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="timeRequest" name="{{ 'REQUESTED' | translate }}" [maxWidth]="200" [sortable]="true">
      <ng-template let-response="row" ngx-datatable-cell-template>
        {{ response.timeRequest ? (response.timeRequest | cDate: 'L LTS') : '-' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="timeAnswer" name="{{ 'ANSWERED' | translate }}" [maxWidth]="200" [sortable]="true">
      <ng-template let-response="row" ngx-datatable-cell-template>
        {{ response.timeAnswer ? (response.timeAnswer | cDate: 'L LTS') : '-' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column prop="answer" name="{{ 'BOX_ANSWER' | translate }}" [sortable]="true">
      <ng-template let-response="row" ngx-datatable-cell-template>
        <div class="overflow-hidden text-ellipsis text-ellipsis-multiline font-mono text-sm">
          {{ response.answer ? response.answer : '-' }}
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
}
